import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { AcademyService } from "../academies/service/academies.service";
import { ReportService } from "src/app/services/report.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from "primeng/table";

@Component({
  selector: 'app-tournament-revenue',
  templateUrl: './tournament-revenue.component.html',
  styleUrls: ['./tournament-revenue.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class TournamentRevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  tournamentRevenueData: any;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  searchby;
  public hide: boolean = true;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  academiesList: any;
  academyTournamentsList: any[] = [];
  country: any;
  state: any;
  cityName: any;
  sportName: string = 'Tennis';
  academyId: any;
  tournamentId: any;
  downloadTournamentRevenueDataList: any;

  constructor(
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private categoryService: CategoryService,
    private academyService: AcademyService,
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Tournament start date', value: "created_at" }
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
  }

  
  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }
  
  getAcademyTournamentList() {
    this.academyTournamentsList = [];
    let query = `?filterBySportType=${this.sportName}`;
    if (this.startDate != undefined && this.endDate != undefined) {
      query += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      query += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    this.reportService.getFilteredReportsTournaments(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.academiesList = data.academyList;
      this.academyTournamentsList = data.data;
    }, err => {
        this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    this.stateList = [];
    this.cityList = [];
    this.state = null;
    this.cityName = null;
    if (event.value !== null) {
      let countryCode = event.value.iso2;
      let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
      this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let stateObj = {
              name: element.name,
              id: element.id,
            }
            this.stateList.push(stateObj);
          });
        }
      })
    }
    this.loadTournamentRevenue(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    this.cityList = [];
    this.cityName = null;
    if (event.value !== null) {
      const stateCode = event.value.id;
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
      this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
    this.loadTournamentRevenue(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = 'Tennis';
    this.academyId = null;
    this.tournamentId = null;
    this.getAcademyTournamentList();
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadTournamentRevenue(resetEvent);
  }

  loadTournamentRevenue(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.country) {
      params += "&filterByCountry=" + this.country.name;
    }

    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }

    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }

    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }

    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }

    if (this.tournamentId) {
      params += "&filterByTournament=" + this.tournamentId;
    }

    const getFilterValue = (field) => {
      if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
        return event.filters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "mobileNumber", parameter: "filterByTournamentMobileNumber" },
      { field: "username", parameter: "filterByTournamentUsername" },
      { field: "academy", parameter: "filterByTournamentAcademy" },
      { field: "sport", parameter: "filterByTournamentSport" },
      { field: "registrationId", parameter: "filterByTournamentRegistrationId" },
      { field: "registrationDate", parameter: "filterByTournamentRegistrationDate" },
      { field: "tournamentName", parameter: "filterByTournamentName" },
      { field: "tournamentHostedBy", parameter: "filterByTournamentHostedBy" },
      { field: "academyId", parameter: "filterByTournamentAcademyId" },
      { field: "tournamentCity", parameter: "filterByTournamentCity" },
      { field: "tournamentState", parameter: "filterByTournamentState" },
      { field: "tournamentCountry", parameter: "filterByTournamentCountry" },
      { field: "category", parameter: "filterByTournamentCategory" },
      { field: "entryFee", parameter: "filterByTournamentEntryFee" },
      { field: "couponApplied", parameter: "filterByTournamentCouponApplied" },
      { field: "tournamentStartDate", parameter: "filterByTournamentStartDateColumn" },
      { field: "tournamentEndDate", parameter: "filterByTournamentEndDateColumn" },
      { field: "couponDiscountAmountHost", parameter: "filterByTournamentCouponDiscountHost" },
      { field: "couponDiscountAmountTPL", parameter: "filterByTournamentCouponDiscountTPL" },
      { field: "tplCommissionPercent", parameter: "filterByTournamentCommissionPercent" },
      { field: "tplCommission", parameter: "filterByTournamentCommission" },
      { field: "finalEntryFee", parameter: "filterByTournamentFinalEntryFee" },
      { field: "gstAmount", parameter: "filterByTournamentGstAmount" },
      { field: "entryFeePayoutToAcademy", parameter: "filterByTournamentPayout" },
      { field: "tplShare", parameter: "filterByTournamentTplShare" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getTournamentRevenue(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.tournamentRevenueData = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportTournamentRevenueReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  formatCommission(value: any): string {
    const num = Number(value);
    if (Number.isInteger(num)) {
      return num.toString();
    }
    return num.toFixed(2);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadTournamentRevenue(this.lastTableLazyLoadEvent);
  }

  async exportTournamentRevenueReportListData(userReportList) {
    this.downloadTournamentRevenueDataList = JSON.parse(JSON.stringify(userReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadTournamentRevenueDataList[prop];
    });

    const summaryHeaders = [
      'Total Number of Users', 'Total Registrations', 'Total No. of Tournaments', 'Total Registration Amount',
      'Total Coupon Amount (Host)', 'Total Coupon Amount (TPL)', 'Total TPL Commission',
      'Total Entry Fee Payout to Academy', 'Total Revenue', 'Total TPL Share'
    ];
    const columnHeaders = [
      'Mobile Number', 'Username', 'Academy', 'Sport', 'Registration ID', 'Registration Date',
      'Tournament Name', 'Tournament Hosted By', 'Academy ID', 'Tournament City', 'Tournament State',
      'Tournament Country', 'Category', 'Entry Fee', 'Coupon Applied', 'Tournament Start Date',
      'Tournament End Date', 'Coupon Discount Amount (Host)', 'Coupon Discount Amount (TPL)',
      'TPL Commission %', 'TPL Commission', 'Final Entry Fee (TPL Revenue)', 'GST Amount',
      'Entry Fee Payout to Academy', 'TPL Share'
    ];
    const { Workbook } = await import('exceljs');
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Tournament_Revenue');

    worksheet.addRow([]);
    const summaryHeaderRow = worksheet.addRow(summaryHeaders);
    summaryHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });
    worksheet.addRow([
      this.downloadTournamentRevenueDataList.summary.totalNumberOfUsers,
      this.downloadTournamentRevenueDataList.summary.totalRegistrations,
      this.downloadTournamentRevenueDataList.summary.totalNumberOfTournaments,
      this.downloadTournamentRevenueDataList.summary.totalRegistrationAmount,
      this.downloadTournamentRevenueDataList.summary.totalCouponAmountHost,
      this.downloadTournamentRevenueDataList.summary.totalCouponAmountTPL,
      this.downloadTournamentRevenueDataList.summary.totalTPLCommission,
      this.downloadTournamentRevenueDataList.summary.totalEntryFeePayoutToAcademy,
      this.downloadTournamentRevenueDataList.summary.totalRevenue,
      this.downloadTournamentRevenueDataList.summary.totalTPLShare,
    ]);
    worksheet.addRow([]);
    const columnHeaderRow = worksheet.addRow(columnHeaders);
    columnHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });

    columnHeaders.forEach((header, index) => {
      worksheet.getColumn(index + 1).width = Math.min(Math.max(header.length + 2, 15), 35);
    });

    this.downloadTournamentRevenueDataList['data'].forEach((parent: any) => {
      if (parent.registrationDate) {
        parent.registrationDate = moment(parent.registrationDate).format("DD-MM-YYYY");
      }
      if (parent.tournamentStartDate) {
        parent.tournamentStartDate = moment(parent.tournamentStartDate).format("DD-MM-YYYY");
      }
      if (parent.tournamentEndDate) {
        parent.tournamentEndDate = moment(parent.tournamentEndDate).format("DD-MM-YYYY");
      }
      worksheet.addRow([
        parent.mobileNumber,
        parent.username,
        parent.academy,
        parent.sport,
        parent.registrationId,
        parent.registrationDate,
        parent.tournamentName,
        parent.tournamentHostedBy,
        parent.academyId,
        parent.tournamentCity,
        parent.tournamentState,
        parent.tournamentCountry,
        parent.category,
        parent.entryFee,
        parent.couponApplied,
        parent.tournamentStartDate,
        parent.tournamentEndDate,
        parent.couponDiscountAmountHost > 0 ? parent.couponDiscountAmountHost : '-',
        parent.couponDiscountAmountTPL > 0 ? parent.couponDiscountAmountTPL : '-',
        parent.tplCommissionPercent,
        parent.tplCommission,
        parent.finalEntryFee,
        parent.gstAmount,
        parent.entryFeePayoutToAcademy,
        parent.tplShare,
      ]);
    });

    const excelBuffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([excelBuffer]), "Tournament_Revenue.xlsx");

    this.downloadFlg = false;
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
